import qs from 'qs';

import { TestDefinition } from '@/modules/partner/model/test-definition';

type TTypeFormTestParams = {
  driverId: string;
  cityName: string;
};

const isTypeform = (params: any): params is TTypeFormTestParams =>
  'driverId' in params && 'cityName' in params;

type TTestParams = TTypeFormTestParams;

const getUrlForTest = (test: TestDefinition, params: TTypeFormTestParams): string => {
  if (test.linkType === 'typeform' && isTypeform(params)) {
    return (
      test.linkUrl +
      `#` +
      qs.stringify({
        driver_id: params.driverId,
        city: params.cityName,
      })
    );
  }

  return test.linkUrl;
};

export type { TTestParams };
export { getUrlForTest };
